<template>
  <a class="justify-between items-center" @click="$emit('click', $event)" v-bind="$attrs">
    <slot></slot>
    <i v-if="!loading" :class="iconClass"></i>
    <i v-else class="fa fa-spinner fa-spin"></i>
  </a>
</template>


<script>
  export default{
    data(){
      return {

      }
    },
    props:{
      iconClass: '',
      loading: false
    }
  }
</script>
<style lang="scss" scoped>
@import "resources/sass/_variables.scss";

  a{
    background: none;
    padding: 10px 10px;
    width: 100%;
    display: block;
    text-align: center;
    font-weight: 300;
    border-radius: 20px;
    border: 1px solid #166cb7;
    color: #166cb7;
    margin-top: 8px;
    margin-bottom: 10px;
    white-space: normal;
  }

  a i{
    display: block;
  }

  a:hover{
    cursor:pointer;
    text-decoration: none;
  }
  
  a.disabled,
  a[disabled]{
    color:gray;
    border: 1px solid gray;
    pointer-events: none;
  }

  a.disabled:hover,
  a[disabled]:hover{
    cursor: not-allowed;
  }
  

  a.primary{
    box-shadow: 0 7px 14px 0 rgba(50,50,93,.1), 0 3px 6px 0 rgba(0,0,0,.07);
    background: var(--primary-button-color);
    color: #fff; 
    border: none;
    border-color: #dc2a55; 
  }

  .btn {
    border-radius:8px;
  }

  a.add {
    background: var(--add-button-color);
    color:white;
    border-radius: var(--primary-border-radius);
    border-color:var(--add-button-color); 
  }



  
</style>